export var detectMobile = function () {
    try {
        var regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        return regex.test(navigator.userAgent);
    }
    catch (_a) {
        return false;
    }
};
